<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-fw fa-user" :class="{'fas': active, 'far': !active}"></i></template>
        <template v-slot:content>
            <div class="t-title">{{ registration.last_name }}, {{ registration.first_name }}</div>
            <div>
                <div class="meta">{{ registration.created_at | moment('MMM D, YYYY')}}</div>
            </div>
        </template>
        <template v-slot:status>
            <div class="stats">
                <span class="stat"><i class="fas fa-fw" :class="{'fa-check': registration.po_pending === 'false', 'fa-ban': registration.po_pending === 'true'}"></i></span>
            </div>
        </template>
        <template v-slot:details>
            <div class="tile-details">
                <div class="data mt-1">
                    <data-row mini title="School">{{ registration.school_name }}</data-row>
                    <data-row mini title="District">{{ registration.district_name }}</data-row>
                    <data-row mini title="Reg Code">{{ registration.code }}</data-row>
                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import Toolbar from "@/TIER/components/Toolbar";
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";
    import moment from "moment";

    export default {
        name: 'RmcRegistrationTile',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            card: {
                required: true
            },
            registration: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        data: function() {
            return {};
        }
    };
</script>

<style lang="scss" scoped>
    @import '../../assets/variables';

    li {
        color: darken($t-primary, 18);
        padding: 0.5rem 0;

        .t-title {
            font-size: .9rem;
            font-weight: 700;
        }

        .tile-details {
            margin-top: 0.5rem;
        }

        .fa-exclamation-triangle {
            color: orangered;
        }

        .fa-check {
            color: green;
        }
    }
</style>
